export default {
  nav: {
    trade: 'Trading',
    dashboard: 'Painel',
    chart: 'Gráfico',
    logs: 'Logs',
    settings: 'Configurações',
    backtest: 'Backtest',
    replay: 'Replay',
    downloadData: 'Baixar dados',
    pairlistConfig: 'Config Pairlist',
    lockLayout: 'Bloquear layout',
    resetLayout: 'Redefinir layout',
    logout: 'Sair',
    exportPdf: 'Exportar como PDF',
  },
  dashboard: {
    profitOverTime: 'Lucro ao longo do tempo (combinado)',
    botComparison: 'Comparação de bots',
    openTrades: 'Trades abertos',
    openTradesDesc: 'Trades abertos de todos os bots selecionados.',
    closedTrades: 'Trades fechados',
    closedTradesDesc: 'Trades fechados de todos os bots selecionados.',
    profitBenchmark: 'Lucro & Benchmarks',
    cumulativeProfit: 'Lucro acumulado',
    profitDistribution: 'Distribuição de lucros',
    tradesLog: 'Log de trades',
    activityTimeline: 'Cronologia de atividade',
    marketOverview: 'Mercado e desempenho',
    performanceHeatmap: 'Mapa de calor de desempenho',
    riskOverview: 'Visão geral de riscos',
    stressTest: 'Teste de stress',
    opened: 'aberto',
    closed: 'fechado',
  },
  // Lucro acumulado melhorado
  cumProfit: {
    title: 'Lucro acumulado',
    tabProfit: 'Lucro',
    tabProfitBalance: 'Lucro + Saldo',
    tabPerBot: 'Por bot',
    tabProportion: 'Proporção',
    profit: 'Lucro',
    balance: 'Saldo',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Nenhum dado de trade disponível',
    statTotalProfit: 'Lucro total',
    statPeak: 'Pico de lucro',
    statDrawdown: 'Drawdown máx.',
    statRecovery: 'Recuperação %',
    statBestBot: 'Melhor bot',
    highWaterMark: 'High Water Mark',
  },

  // Distribuição de lucros melhorada
  profitDist: {
    tabHistogram: 'Histograma',
    tabPerBot: 'Por bot',
    tabPerPair: 'Por par',
    tabByDuration: 'Por duração',
    tradeCount: 'Número de trades',
    profitPct: 'Lucro %',
    avgProfit: 'Lucro médio',
    avgProfitPct: 'Lucro médio %',
    duration: 'Duração',
    trades: 'Trades',
    mean: 'Média',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Nenhum dado de trade disponível',
    statMean: 'Média',
    statMedian: 'Mediana',
    statStdDev: 'Desv. Pad.',
    statSkewness: 'Assimetria',
    statBest: 'Melhor',
    statWorst: 'Pior',
    statWinRate: 'Taxa vitória',
    statTrades: 'Trades',
    skewnessPositive: 'Assimetria positiva: mais grandes ganhos',
    skewnessNegative: 'Assimetria negativa: mais grandes perdas',
    tabByLeverage: 'Por alavancagem',
    leverage: 'Alavancagem',
    filterAll: 'Todos',
    filterSpot: 'Somente spot',
    filterFutures: 'Somente futuros',
    filterLong: 'Somente long',
    filterShort: 'Somente short',
  },

  // Lucro ao longo do tempo melhorado
  profitEnhanced: {
    combined: 'Combinado',
    projected: 'Projetado (incl. abertos)',
    combinedMode: 'Combinado (todos os bots somados)',
    perBotMode: 'Por bot (linhas separadas)',
    stackedMode: 'Área empilhada (contribuição)',
    absLabel: 'USDC',
    profitAbs: 'Lucro (USDC)',
    profitPct: 'Lucro (%)',
    periodReturn: 'Retorno do período',
    bestDay: 'Melhor dia',
    worstDay: 'Pior dia',
    avgDaily: 'Média diária',
    trades: 'Trades',
    sharpe: 'Sharpe',
    maxDD: 'DD Máx',
    winRate: 'Taxa de acerto',
    profitFactor: 'Fator de lucro',
    exportCSV: 'Exportar dados do gráfico como CSV',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Sem dados de trading para este período',
  },

  // Gráfico de Lucro & Benchmarks
  profitBenchmark: {
    tabCombined: 'Combinado',
    tabPerBot: 'Por bot',
    tabCumulative: 'Acumulativo',
    combined: 'Combinado',
    projected: 'Projetado (incl. abertos)',
    highWaterMark: 'High Water Mark',
    normAbsolute: 'Absoluto',
    normPctFromStart: '% desde o início',
    normPctFromCapital: '% do capital',
    profitAbs: 'Lucro',
    profitPct: 'Lucro (%)',
    benchmarkPct: 'Benchmark (%)',
    periodReturn: 'Retorno do período',
    vsBTC: 'vs BTC',
    sharpe: 'Sharpe',
    maxDD: 'DD Máx',
    winRate: 'Taxa de acerto',
    benchmarks: 'Benchmarks',
    normalization: 'Normalização',
    normExplain: 'Como funciona',
    normExplainDetail: 'No modo "% desde o início", seu lucro e os benchmarks começam em 0% e mostram a variação percentual. Isso permite comparar diretamente: seus bots superaram o BTC?',
    altProxy: 'proxy mercado alt',
    solLabel: 'Solana',
    bnbLabel: 'BNB Chain',
    traditionalNote: 'Benchmarks de mercados tradicionais requerem chave API',
    settings: 'Configurações do gráfico',
    exportCSV: 'Exportar dados como CSV',
    exportPNG: 'Exportar gráfico como imagem PNG',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Sem dados de trading para este período',
    currencySelector: 'Moeda de exibição',
    currencyAuto: 'Auto',
    addBenchmark: 'Adicionar benchmark',
    removeBenchmark: 'Remover benchmark {coin}',
    customCoinGecko: 'Personalizado (ID CoinGecko)',
    customPlaceholder: 'ex. cardano',
    customNotFound: 'ID não encontrado no CoinGecko',
    add: 'Adicionar',
    outperforming: 'Superando',
    underperforming: 'Abaixo de',
    by: 'por',
    descCombined: 'Este gráfico mostra o lucro combinado de todos os bots selecionados',
    descPerBot: 'Este gráfico mostra o lucro individual de cada bot',
    descCumulative: 'Este gráfico mostra o total acumulado de lucros',
    descOverPeriod: 'nos últimos {period}',
    descNormPctStart: 'expresso como variação percentual desde o início do período',
    descNormAbsolute: 'em {currency}',
    descNormPctCapital: 'como percentual do capital inicial',
    descBenchmarks: 'Comparação benchmark: {list}',
    descBenchmarkHint: 'Se sua linha de lucro está ACIMA de um benchmark, você o está superando.',
  },

  botComparison: {
    botName: 'Nome do bot',
    all: 'Todos',
    showInDashboard: 'Mostrar este bot no painel',
    toggleAll: 'Alternar todos os bots',
    selectAllBots: 'Clique para selecionar todos os bots',
    selectDryBots: 'Clique para selecionar bots dry run',
    selectLiveBots: 'Clique para selecionar bots live',
    trades: 'Trades',
    openProfit: 'Lucro aberto',
    totalProfit: 'Lucro total (aberto e realizado)',
    closedProfit: 'Lucro fechado',
    withdrawnLabel: 'dos quais {amount} retirados',
    netAfterWithdrawals: '{amount} líquido após retiradas',
    balance: 'Saldo',
    winLoss: 'G/P',
    offline: 'Offline',
    offlineSince: 'desde {duration}',
    dry: 'Dry',
    live: 'Live',
    exchange: 'Exchange',
    selectByExchange: 'Clique para selecionar todos os bots {exchange}',
    stakeAmount: 'Valor apostado',
    port: 'Porta',
    strategy: 'Estratégia',
    stakeCurrencyLabel: 'Moeda',
    selectByCurrency: 'Clique para selecionar todos os bots {currency}',
    weeklyProfit: 'Lucro semanal',
    yearlyProfit: 'Lucro anual',
    monthlyProfit: 'Lucro mensal',
    addColumn: 'Adicionar coluna',
    hideColumn: 'Clique para ocultar esta coluna',
    botOfflineDesc: 'Este bot está atualmente offline. Nenhum dado ao vivo disponível.',
    lastSeenOnline: 'Último acesso há {duration}',
    botLoading: 'O bot está a iniciar...',
    botLoadingDesc: 'Aguarde o carregamento das informações adicionais.',
    resetColumns: 'Restaurar as colunas FreqUI ao estado predefinido',
    columnSettings: 'Colunas visíveis',
    correlation: 'Correlação detetada',
    correlationDesc: 'Vários bots a operar o mesmo par simultaneamente',
    renameBot: 'Renomear bot',
    dragToReorder: 'Arrastar para reordenar',
    statusLabel: 'Estado',
    onlineSince: 'Online desde há {duration}',
    // Sort & Filter
    sort: 'Ordenar',
    sortBy: 'Ordenar por',
    ascending: 'Ascendente',
    descending: 'Descendente',
    filters: 'Filtros',
    visibility: 'Visibilidade',
    showOnlineSince: 'Mostrar data de conexão',
    botTags: 'Tags do bot',
    byStatus: 'Por estado',
    byExchange: 'Por exchange',
    byCurrency: 'Por moeda',
    botsHidden: '{count} bot oculto | {count} bots ocultos',
    allBotsVisible: 'Todos os bots estão visíveis',
    botsHiddenByFilters: '{count} bot oculto por filtros | {count} bots ocultos por filtros',
    showAllBots: 'Clique para mostrar todos os bots',
    sortCustom: 'Ordem personalizada',
    sortByName: 'Nome do bot',
    sortByStartDate: 'Data de início',
    sortByProfit: 'Lucro fechado',
    sortByBalance: 'Saldo',
    sortByCurrency: 'Moeda',
    sortByExchange: 'Exchange',
    sortByStatus: 'Estado',
    sortByStrategy: 'Estratégia',
    sortByWeekly: 'Lucro semanal',
    sortByMonthly: 'Lucro mensal',
    sortByDrawdown: 'Drawdown',
    sortByWinrate: 'Taxa de acerto',
    sortByTradeCount: 'Número de trades',
    sortByOpenPositions: 'Posições abertas',
    tagStatus: 'Estado (Dry/Live/Offline)',
    tagExchange: 'Exchange',
    tagCurrency: 'Moeda de aposta',
    tagPort: 'Porta',
    tagTradingMode: 'Modo de trading (Futures/Spot)',
    byTradingMode: 'Por modo de trading',
    filtersTitle: 'Filtros',
    resetSort: 'Redefinir ordenação',
    resetFilters: 'Redefinir filtros',
    // Alerts
    alerts: 'Alertas',
    alertEnabled: 'Alerta ativado',
    lossThreshold: 'Limite de perda',
    positionAtRisk: 'Posição em risco: perda não realizada excede o limite',
    // Alert system v2
    alertsReset: 'Redefinir',
    alertCategoryPosition: 'Posição',
    alertCategoryLog: 'Logs',
    alertCategoryActivity: 'Atividade',
    alertCategorySystem: 'Sistema',
    alertPositionLoss: 'Perda não realizada',
    alertPositionLossDesc: 'A perda da posição excede o limite',
    alertPositionStuck: 'Posição presa',
    alertPositionStuckDesc: 'Mantida mais de X vezes a duração média',
    alertNearLiquidation: 'Perto da liquidação',
    alertNearLiquidationDesc: 'A menos de X% do preço de liquidação (futuros)',
    alertLogErrors: 'Erros nos logs',
    alertLogErrorsDesc: 'Erros detetados nos logs recentes',
    alertOrderFailed: 'Ordem falhada',
    alertOrderFailedDesc: 'Não foi possível abrir ou fechar uma posição',
    alertInsufficientFunds: 'Fundos insuficientes',
    alertInsufficientFundsDesc: 'Fundos insuficientes para abrir posição',
    alertExchangeError: 'Erro da exchange',
    alertExchangeErrorDesc: 'Problemas de conectividade com a exchange',
    alertWalletMismatch: 'Dessincronização da carteira',
    alertWalletMismatchDesc: 'Discrepância detetada no saldo da carteira',
    alertNoTradeActivity: 'Sem atividade de trading',
    alertNoTradeActivityDesc: 'Nenhum trade aberto em X horas',
    alertBotOffline: 'Bot offline',
    alertBotOfflineDesc: 'O bot ficou offline',
    alertHighDrawdown: 'Drawdown elevado',
    alertHighDrawdownDesc: 'O drawdown atual excede o limite',
    alertCapacityFull: 'Capacidade cheia',
    alertCapacityFullDesc: 'Todos os slots de trade estão ocupados',
    alertAllFundsExposed: 'Todos os fundos expostos',
    alertAllFundsExposedDesc: 'Quase todo o capital está bloqueado em posições abertas',
    alertLiquidationBeforeStoploss: 'Liquidação antes do stoploss',
    alertLiquidationBeforeStoplossDesc: 'O preço de liquidação está mais perto que o stoploss (futuros)',
    alertIncludeLeverage: 'Incluir alavancagem',
    alertPerBot: 'Por bot',
    alertAllConfigured: '{count} alerta configurado | {count} alertas configurados',
    alertToggleAllOn: 'Todos ON',
    alertToggleAllOff: 'Todos OFF',
    alertGlobalApply: 'As configurações aplicam-se a todos os bots. Ative por bot abaixo.',
    alertActiveCount: '{count} alerta ativo | {count} alertas ativos',
    alertViewLogs: 'Ver logs',
    // Bot Groups
    botGroups: 'Grupos de bots',
    createGroup: 'Criar grupo',
    deleteGroup: 'Eliminar grupo',
    ungrouped: 'Sem grupo',
    groupName: 'Nome do grupo',
    groupIcon: 'Ícone',
    addToGroup: 'Adicionar ao grupo',
    removeFromGroup: 'Remover do grupo',
    createGroupInline: 'Criar um grupo',
    changeIcon: 'Mudar ícone',
    clearIcon: 'Remover ícone',
    resetIcon: 'Redefinir ícone',
    searchIcon: 'Buscar emoji…',
    recentIcons: 'Usados recentemente',
    noIconResults: 'Nenhum emoji corresponde à sua pesquisa',
    editGroup: 'Editar grupo',
    alertsTitle: 'Configurações de alertas',
    groupsTitle: 'Grupos de bots',
    noAlerts: 'Sem alertas',
    positionsAtRisk: '{count} posição em risco | {count} posições em risco',
    ungroupedBots: 'Bots sem grupo',
    // Custom Tags
    customTags: 'Tags personalizadas',
    addTag: 'Adicionar tag',
    createTag: 'Criar tag',
    tagName: 'Nome da tag',
    tagColor: 'Cor',
    deleteTag: 'Eliminar tag',
    editTag: 'Editar tag',
    filterByTag: 'Clique para selecionar bots com esta tag',
    byCustomTag: 'Por tag personalizada',
    exportCSV: 'Exportar como CSV',
    keyboardShortcuts: 'Atalhos de teclado: Esc=fechar popovers, 1-9=alternar bot, F=filtro, S=ordenar, Ctrl+A=selecionar tudo',
  },
  profit: {
    profitsFor: 'Lucros para',
    all: 'Todos',
    long: 'Long',
    short: 'Short',
    trades: 'Trades',
    metric: 'Métrica',
    value: 'Valor',
    roiClosed: 'ROI trades fechados',
    roiAll: 'ROI todos os trades',
    totalTradeCount: 'Total de trades',
    botStarted: 'Bot iniciado',
    firstTradeOpened: 'Primeiro trade aberto',
    latestTradeOpened: 'Último trade aberto',
    winLoss: 'Ganhos / Perdas',
    winrate: 'Taxa de acerto',
    expectancy: 'Expectativa (razão)',
    cagr: 'CAGR',
    calmar: 'Calmar',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    sqn: 'SQN',
    pvalue: 'P-Value',
    avgDuration: 'Duração média',
    bestPerforming: 'Melhor desempenho',
    tradingVolume: 'Volume de trading',
    profitFactor: 'Fator de lucro',
    withdrawn: 'Retirado',
    netProfit: 'Lucro líquido (após retiradas)',
    maxDrawdown: 'Drawdown máximo',
    currentDrawdown: 'Drawdown atual',
  },
  balance: {
    title: 'Saldo do bot / Saldo da conta',
    available: 'Disponível',
    total: 'Total',
    increaseOverCapital: 'Aumento sobre o capital inicial de',
    currency: 'Moeda',
    in: 'em',
    showingAccount: 'A mostrar saldo da conta',
    showingBot: 'A mostrar saldo do bot',
    hideSmall: 'Ocultar saldos pequenos',
    showAll: 'Mostrar todos os saldos',
  },
  tradeList: {
    id: 'ID',
    pair: 'Par',
    amount: 'Quantidade',
    stakeAmount: 'Valor apostado',
    totalStakeAmount: 'Valor total apostado',
    openRate: 'Preço de entrada',
    currentRate: 'Preço atual',
    closeRate: 'Preço de saída',
    currentProfit: 'Lucro atual %',
    profit: 'Lucro %',
    openDate: 'Data de abertura',
    closeDate: 'Data de fechamento',
    closeReason: 'Razão de fechamento',
    bot: 'Bot',
    filter: 'Filtrar',
    noTrades: 'Nenhum trade para exibir.',
    short: 'Short',
    long: 'Long',
    exitTrade: 'Fechar trade',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    confirmExit: 'Realmente fechar o trade {id} (Par {pair}) usando ordem {orderType}?',
    confirmDelete: 'Realmente excluir o trade {id} (Par {pair})?',
    cancelOpenOrder: 'Cancelar a ordem aberta para o trade {id} (Par {pair})?',
    currentlyNoOpen: 'Nenhum trade aberto no momento.',
    noClosedTrades: 'Nenhum trade fechado até agora.',
  },

  // Listas de trades aprimoradas
  enhancedTrades: {
    trades: 'trades',
    filterPlaceholder: 'Filtrar por par, bot, tag...',
    columnSettings: 'Configurações de colunas',
    colBotState: 'Estado',
    colBot: 'Bot',
    colTradeId: 'ID',
    colPair: 'Par',
    colType: 'Tipo',
    colLeverage: 'Alavancagem',
    colEntryPrice: 'Preço de entrada',
    colCurrentPrice: 'Preço atual',
    colProfitPct: 'Lucro %',
    colProfitAbs: 'Lucro',
    colStake: 'Investimento',
    colDuration: 'Duração',
    colOpenSince: 'Aberto desde',
    colOpenReason: 'Motivo de abertura',
    colStoplossDist: 'Dist. Stoploss',
    colDurationAnomaly: 'Saúde duração',
    colActions: 'Ações',
    colClosePrice: 'Preço de saída',
    colCloseReason: 'Razão de fechamento',
    colCloseDuration: 'Duração de retenção',
    colClosedAgo: 'Fechado há',
    colFee: 'Taxas',
    durationOk: 'Duração normal (< 24h)',
    durationWarn: 'Duração estendida (24-72h)',
    durationDanger: 'Duração crítica (> 72h)',
    popoverEntry: 'Preço de entrada',
    popoverCurrent: 'Preço atual',
    popoverClose: 'Preço de saída',
    popoverProfit: 'Lucro',
    popoverDuration: 'Duração',
    popoverStoploss: 'Stoploss',
    popoverLiquidation: 'Liquidação',
    min: 'Mín',
    max: 'Máx',
    actions: 'Ações',
    actionsFor: 'Ações para {pair}',
    closeActionsMenu: 'Fechar menu de ações',
  },

  // Visualizador de logs melhorado
  logViewer: {
    levelAll: 'Todos',
    levelInfo: 'Info',
    levelWarning: 'Aviso',
    levelError: 'Erro',
    hideHeartbeat: 'Ocultar heartbeat',
    hideHeartbeatTooltip: 'Oculta as mensagens periodicas de verificacao de saude do bot (Bot heartbeat PID=..., state=RUNNING). Sao normais e nao indicam nenhum problema.',
    hideWebSocket: 'Ocultar WebSocket',
    hideWebSocketTooltip: 'Oculta as mensagens de conexao/desconexao WebSocket do servidor API. Estas ocorrem quando a aba do FreqUI se conecta ou desconecta.',
    search: 'Pesquisar nos logs...',
    compact: 'Compacto',
    autoScroll: 'Auto-rolagem',
    refresh: 'Recarregar logs',
    scrollToBottom: 'Ir para o final',
    entries: 'entradas',
    noEntries: 'Nenhuma entrada de log corresponde aos filtros atuais.',
  },

  // Popover detalhe de trade
  tradePopover: {
    entryPrice: 'Preco de entrada',
    currentPrice: 'Preco atual',
    exitPrice: 'Preco de saida',
    profit: 'Lucro',
    duration: 'Duracao',
    stake: 'Investimento',
    entryTag: 'Tag de entrada',
    dcaHistory: 'Historico DCA',
    entries: 'entradas',
    entriesNoDetail: 'entradas (sem detalhes de ordens)',
    priceLevels: 'Niveis de preco',
    entry: 'Entrada',
    current: 'Atual',
    exit: 'Saida',
    sl: 'SL',
    liq: 'Liq.',
    stoplossInfo: 'Info Stoploss',
    initialSl: 'SL inicial',
    currentSl: 'SL atual',
    distancePct: 'Distancia %',
    stoploss: 'Stoploss',
    liquidation: 'Liquidacao',
    exitInfo: 'Info de saida',
    exitReason: 'Razao de saida',
    totalDuration: 'Duracao total',
    durationHealth: 'Saude da duracao',
    currentDuration: 'Atual',
    avgAllDuration: 'Media (todos)',
    avgWinDuration: 'Media (vencedores)',
    avgLoseDuration: 'Media (perdedores)',
    percentile: 'Percentil',
    fast: 'Rapido',
    slow: 'Lento',
  },

  // Popover saude da duracao
  durationHealth: {
    title: 'Analise de saude da duracao',
    current: 'Duracao atual',
    avgAll: 'Media (todos os trades)',
    avgWin: 'Media (vencedores)',
    avgLose: 'Media (perdedores)',
    percentile: 'Percentil',
    sampleSize: 'Baseado em',
    trades: 'trades',
    fast: 'Rapido',
    slow: 'Lento',
    explainClosed: 'Este trade está fechado. A duração mostra por quanto tempo a posição foi mantida.',
    explainOk: 'A duracao deste trade esta dentro da faixa normal.',
    explainWarn: 'Este trade esta demorando mais que a maioria. Considere monitora-lo de perto.',
    explainDanger: 'Este trade esta aberto por muito mais tempo que a media. Pode estar travado.',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Nao ha dados de trades fechados disponiveis para analise.',
  },

  // Stoploss Chart Popover
  stoplossChart: {
    loading: 'Carregando grafico...',
    loadingPriceData: 'Carregando dados de precos...',
    unavailable: 'Grafico indisponivel',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Nenhum dado de vela retornado',
    fetchError: 'Falha ao buscar dados de velas',
    botNotFound: 'Bot store nao encontrado',
    tradeTooOld: 'Trade aberto antes do intervalo de velas disponivel',
    entryPrice: 'Entrada',
    stoploss: 'Stoploss',
    currentPrice: 'Atual',
    liquidation: 'Liquidacao',
    dcaEntries: 'Entradas DCA',
  },

  // Exit Reason Stats Popover
  exitReasonStats: {
    title: 'Analise de razoes de saida',
    exitReason: 'Razao de saida',
    entryTag: 'Tag de entrada',
    reasonDistribution: 'Razoes de saida (todos os trades)',
    tagDistribution: 'Tags de entrada (todos os trades)',
  },

  // Type Stats Popover
  typeStats: {
    title: 'Estatisticas Long vs Short',
    long: 'Long',
    short: 'Short',
    count: 'Trades',
    winRate: 'Taxa de sucesso',
    avgProfit: 'Lucro medio',
  },

  // Leverage Stats Popover
  leverageStats: {
    title: 'Analise de alavancagem',
    avgLeverage: 'Alavancagem media',
    trades: 'trades',
    avg: 'med',
  },

  // Duration Box Plot Popover
  durationBox: {
    title: 'Distribuicao de duracao',
    median: 'Mediana',
    thisTrade: 'Este trade',
    sample: 'Tamanho da amostra',
    trades: 'trades',
  },

  tradeDetail: {
    general: 'Geral',
    tradeId: 'ID do trade',
    pair: 'Par',
    openDate: 'Data de abertura',
    entryTag: 'Tag de entrada',
    stake: 'Aposta',
    totalStake: 'Aposta total',
    amount: 'Quantidade',
    openRate: 'Preço de abertura',
    currentRate: 'Preço atual',
    closeRate: 'Preço de fechamento',
    closeDate: 'Data de fechamento',
    realizedProfit: 'Lucro realizado',
    totalProfit: 'Lucro total',
    currentProfit: 'Lucro atual',
    closeProfit: 'Lucro no fechamento',
    details: 'Detalhes',
    minRate: 'Preço mín',
    maxRate: 'Preço máx',
    openFees: 'Taxas de abertura',
    closeFees: 'Taxas de fechamento',
    stoploss: 'Stop-loss',
    atRisk: 'Capital em risco',
    atRiskDesc: 'O valor em risco baseado na aposta. Quanto você perderia se o stop-loss fosse atingido.',
    currentStoplossDist: 'Distância stop-loss atual',
    initialStoploss: 'Stop-loss inicial',
    stoplossLastUpdated: 'Última atualização do stop-loss',
    direction: 'Direção',
    fundingFees: 'Taxas de financiamento',
    interestRate: 'Taxa de juros',
    liquidationPrice: 'Preço de liquidação',
    orders: 'Ordens',
  },
  controls: {
    startTrading: 'Iniciar trading',
    stopTrading: 'Parar trading',
    pause: 'Pausar (StopBuy)',
    reloadConfig: 'Recarregar config',
    forceExitAll: 'Forçar saída de todos',
    forceEnter: 'Forçar entrada',
    stopBot: 'Parar bot',
    stopBotConfirm: 'Parar o loop de execução do bot?',
    pauseStopEntering: 'Pausar - Parar entradas',
    reload: 'Recarregar',
    reloadConfirm: 'Recarregar configuração (incluindo estratégia)?',
    forceExitAllConfirm: 'Realmente forçar a saída de TODOS os trades?',
  },
  forceEntry: {
    title: 'Forçar entrada de trade',
    increasingPosition: 'Aumentando posição para {pair}',
    orderDirection: 'Direção da ordem (Long ou Short)',
    pair: 'Par',
    price: 'Preço [opcional]',
    stakeAmount: 'Valor em {stake} [opcional]',
    leverage: 'Alavancagem [opcional]',
    orderType: 'Tipo de ordem',
    market: 'Mercado',
    limit: 'Limite',
    entryTag: 'Tag de entrada personalizado [opcional]',
    cancel: 'Cancelar',
    enterPosition: 'Entrar na posição',
  },
  forceExit: {
    title: 'Forçar saída',
    exitingTrade: 'Saindo do Trade #{id} {pair}.',
    currentlyOwning: 'Posição atual: {amount} {currency}',
    amount: 'Quantidade em {currency} [opcional]',
    limitOnly: 'Disponível apenas com ordens limite',
    orderType: 'Tipo de ordem',
    price: 'Preço',
    cancel: 'Cancelar',
    exitPosition: 'Sair da posição',
  },
  settings: {
    title: 'Configurações FreqUI',
    uiVersion: 'Versão da interface',
    uiSettings: 'Configurações da interface',
    language: 'Idioma',
    lockLayouts: 'Bloquear layouts',
    lockLayoutsDesc: 'Bloquear layouts dinâmicos para impedir movimentação.',
    resetLayout: 'Redefinir layout',
    resetLayoutDesc: 'Redefinir layouts ao estado original.',
    showOpenTrades: 'Mostrar trades abertos no cabeçalho',
    showOpenTradesDesc: 'Decidir se os trades abertos devem ser visualizados',
    utcTimezone: 'Fuso horário UTC',
    utcTimezoneDesc: 'Selecionar fuso horário (UTC recomendado)',
    backgroundSync: 'Sincronização em segundo plano',
    backgroundSyncDesc: 'Manter sincronização enquanto outro bot está selecionado.',
    confirmDialog: 'Diálogo de confirmação para saídas',
    confirmDialogDesc: 'Usar diálogos de confirmação ao forçar saída de trades.',
    showMultiPaneText: 'Texto nos botões multi-painel',
    showMultiPaneTextDesc: 'Mostrar texto nos botões multi-painel.',
    chartSettings: 'Configurações do gráfico',
    chartScaleSide: 'Lado da escala',
    left: 'Esquerda',
    right: 'Direita',
    chartScaleDesc: 'A escala deve ser exibida à direita ou à esquerda?',
    heikinAshi: 'Usar velas Heikin Ashi',
    heikinAshiDesc: 'Usar velas Heikin Ashi nos gráficos',
    onlyNecessaryColumns: 'Solicitar apenas colunas necessárias',
    onlyNecessaryColumnsDesc: 'Pode reduzir o tamanho da transferência.',
    defaultCandles: 'Número padrão de velas (padrão 250)',
    candleColorPref: 'Preferência de cor das velas',
    greenUpRedDown: 'Verde sobe / Vermelho desce',
    greenDownRedUp: 'Verde desce / Vermelho sobe',
    notificationSettings: 'Configurações de notificação',
    entryNotifications: 'Notificações de entrada',
    exitNotifications: 'Notificações de saída',
    entryCancelNotifications: 'Notificações de cancelamento de entrada',
    exitCancelNotifications: 'Notificações de cancelamento de saída',
    // Browser notifications
    browserNotifications: 'Notificações do navegador',
    enableBrowserNotifications: 'Ativar notificações do navegador',
    enableBrowserNotificationsDesc: 'Receber notificações do navegador quando alertas são acionados (perda de posição, bot offline, erros nos logs).',
    notificationsDenied: 'As notificações do navegador estão bloqueadas. Ative-as nas configurações do navegador.',
    notifyPositionLoss: 'A perda da posição excede o limite',
    notifyBotOffline: 'O bot fica offline',
    notifyLogErrors: 'Erros detetados nos logs',
    backtestSettings: 'Configurações de backtest',
    backtestMetrics: 'Métricas de backtest',
    backtestMetricsDesc: 'Selecionar métricas a exibir por par / tag.',
    // Dashboard section
    dashboardSettings: 'Painel',
    // About section
    aboutSection: 'Sobre',
    freqtradeVersion: 'Versao do Freqtrade',
    credits: 'Construido com FreqUI -- Interface de bot de trading de codigo aberto',
  },
  performance: {
    title: 'Desempenho',
    entries: 'Entradas',
    exits: 'Saídas',
    mixTag: 'Tag misto',
    pair: 'Par',
    profitPct: 'Lucro %',
    profitStake: 'Lucro {stake}',
    count: 'Contagem',
    enterTag: 'Tag de entrada',
    exitReason: 'Razão de saída',
  },
  pairlist: {
    whitelistMethods: 'Métodos da whitelist',
    whitelist: 'Lista branca',
    listUnavailable: 'Lista indisponível. Faça login e verifique se o servidor está funcionando.',
    blacklist: 'Lista negra',
    blacklistDesc: "Lista negra - Selecione e clique em '-' para remover pares",
    addToBlacklist: 'Adicionar par à lista negra',
    selectToDelete: 'Selecione pares para excluir da sua lista negra.',
    pair: 'Par',
  },
  pairLocks: {
    title: 'Bloqueios de pares',
    pair: 'Par',
    until: 'Até',
    reason: 'Razão',
    actions: 'Ações',
    deleteLock: 'Excluir bloqueio',
  },
  backtest: {
    title: 'Backtesting',
    mustBeWebserver: 'O bot deve estar em modo webserver para ativar o Backtesting.',
    loadResults: 'Carregar resultados',
    runBacktest: 'Executar backtest',
    analyzeResult: 'Analisar resultado',
    compareResults: 'Comparar resultados',
    visualizeSummary: 'Visualizar resumo',
    visualizeResult: 'Visualizar resultado',
    running: 'Backtest em execução',
    params: 'Parâmetros do backtest',
    timeframe: 'Timeframe',
    detailTimeframe: 'Timeframe detalhado',
    detailTimeframeDesc: 'Timeframe detalhado para simular resultados intra-vela.',
    maxOpenTrades: 'Trades abertos máx',
    useStrategyDefault: 'Usar padrão da estratégia',
    startingCapital: 'Capital inicial',
    useConfigDefault: 'Usar padrão da config',
    stakeAmount: 'Valor apostado',
    unlimitedStake: 'Aposta ilimitada',
    enableProtections: 'Ativar proteções',
    cacheResults: 'Armazenar resultados em cache',
    enableFreqAI: 'Ativar FreqAI',
    enableFreqAIDesc: 'Assume que o FreqAI está configurado.',
    freqAIIdentifier: 'Identificador FreqAI',
    freqAIModel: 'Modelo FreqAI',
    summary: 'Resumo do backtest',
    resultFor: 'Resultado do backtest para {strategy}',
    strategySettings: 'Configurações da estratégia',
    setting: 'Configuração',
    value: 'Valor',
    metrics: 'Métricas',
    resultsPerEnterTag: 'Resultados por tag de entrada',
    resultsPerExitReason: 'Resultados por razão de saída',
    resultsMixedTag: 'Resultados tag misto',
    resultsPerPair: 'Resultados por par',
    periodicBreakdown: 'Detalhamento periódico',
    startBacktest: 'Iniciar backtest',
    loadBacktestResult: 'Carregar resultado do backtest',
    stopBacktest: 'Parar Backtest',
    resetBacktest: 'Redefinir Backtest',
    singleTrades: 'Trades individuais',
    wins: 'Ganhos',
    draws: 'Empates',
    losses: 'Perdas',
    avgProfit: 'Lucro médio %',
    totProfitStake: 'Lucro total {stake}',
    totProfitPct: 'Lucro total %',
  },
  periodBreakdown: {
    title: 'Detalhamento por período',
    dailyBreakdown: 'Detalhamento diário',
    days: 'Dias',
    weeks: 'Semanas',
    months: 'Meses',
    years: 'Anos',
    weekday: 'Dia da semana',
    date: 'Data',
    totalProfit: 'Lucro total',
    profitFactor: 'Fator de lucro',
    winRate: 'Taxa de acerto',
    absProfit: 'Abs $',
    relProfit: 'Rel %',
    day: 'Dia',
    profit: 'Lucro',
    inFiat: 'Em {currency}',
    trades: 'Trades',
    profitPct: 'Lucro %',
  },
  downloadData: {
    title: 'Download de dados',
    selectPairs: 'Selecionar pares',
    pairsFromTemplate: 'Pares do modelo',
    addAllPairs: 'Adicionar todos os pares da config Pairlist.',
    selectTimeframes: 'Selecionar timeframes',
    timeSelection: 'Seleção de período',
    daysToDownload: 'Dias para baixar',
  },
  botStatus: {
    running: 'Freqtrade em execução',
    runningWith: 'Em execução com',
    on: 'em',
    in: 'em',
    spot: 'spot',
    markets: 'mercados, com estratégia',
    stoplossOnExchange: 'Stop-loss na exchange está',
    enabled: 'ativado',
    disabled: 'desativado',
    currently: 'Atualmente',
    forceEntry: 'forçar entrada',
    dryRun: 'Dry-Run',
    live: 'Live',
    avgProfit: 'Lucro médio',
    tradesAvgDuration: 'Trades, com duração média de',
    bestPair: 'Melhor par',
    botStartDate: 'Data de início',
    firstTradeOpened: 'Primeiro trade aberto',
    lastTradeOpened: 'Último trade aberto',
    profitFactor: 'Fator de lucro',
    tradingVolume: 'Volume de trading',
    strategyParams: 'Parâmetros da estratégia',
  },
  general: {
    autoRefresh: 'Atualização automática',
    autoRefreshAll: 'Atualizar todos os bots agora',
    supported: 'Suportado',
    unsupported: 'Não suportado',
    version: 'Versão',
    noBotSelected: 'Nenhum bot selecionado',
    online: 'Online',
    offline: 'Offline',
    starting: 'A iniciar...',
    confirmDialogDeactivated: 'Diálogo de confirmação desativado. Cuidado.',
  },
  // Alert Detail Card
  alertDetail: {
    stakeAtRisk: 'Aposta em risco',
    ifClosedNow: 'Se fechado agora',
    heldFor: 'Mantida há {duration} (média: {avg})',
    lastError: 'Último erro',
    viewLogs: 'Ver logs',
    away: 'de distância',
    currentPrice: 'Preço atual',
    liqPrice: 'Preço liq.',
    locked: 'Bloqueado',
    free: 'Livre',
    lastSeen: 'Último acesso',
    offlineFor: 'Offline há',
    peakValue: 'Valor máximo',
    currentValue: 'Valor atual',
  },

  // Open Profit Card
  openProfitCard: {
    unrealizedPnl: 'PnL não realizado',
    onCapitalAtRisk: 'sobre capital em risco',
    positions: 'POSIÇÕES',
    positionDetails: 'Detalhes da posição',
    noOpenTrades: 'Nenhum trade aberto',
    bestPosition: 'Melhor posição',
    worstPosition: 'Pior posição',
    riskAnalysis: 'Análise de risco',
    highestLoss: 'Maior perda',
    highestGain: 'Maior ganho',
    avgPositionProfit: 'Lucro médio por posição',
    weightedAvgProfit: 'Lucro médio ponderado',
    totalStakeLocked: 'Total apostado bloqueado',
    mostLoss: 'Maior perda',
    mostGain: 'Maior ganho',
    durationContext: 'Contexto de duração',
    avgOpenDuration: 'Duração média aberta',
    avgClosedDuration: 'Duração média fechada',
    exceedAvg: 'excedem 2x a média',
    historicalRange: 'Intervalo histórico',
    median: 'Mediana',
  },

  // Closed Profit Card
  closedProfitCard: {
    realizedPerformance: 'Desempenho realizado',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Sem dados de lucro disponíveis',
    netAfterWithdrawals: 'Líquido após retiradas',
    winRateStats: 'Taxa de acerto e estatísticas',
    totalTrades: 'Total de trades',
    avgProfitTrade: 'Média / trade',
    performanceMetrics: 'Métricas de desempenho',
    timeAnalysis: 'Análise temporal',
    tradingSpan: 'Período de trading',
    avgTradesPerWeek: 'Média de trades / semana',
    avgTradesPerMonth: 'Média de trades / mês',
    avgProfitWeek: 'Lucro médio / semana',
    avgProfitMonth: 'Lucro médio / mês',
    bestPair: 'Melhor par',
    withdrawalSummary: 'Resumo de retiradas',
    totalWithdrawn: 'Total retirado',
    netProfitAfter: 'Lucro líquido após',
    effectiveRoi: 'ROI efetivo',
  },

  // Win/Loss Card
  winLossCard: {
    title: 'Análise de ganhos/perdas',
    winrate: 'TAXA DE ACERTO',
    wins: 'ganhos',
    losses: 'perdas',
    totalTrades: 'total de trades',
    analysis: 'Análise',
    currentStreak: 'Sequência atual',
    avgWinLossRatio: 'Rácio médio ganho/perda',
    avgProfitPerTrade: 'Lucro médio / trade',
    profitFactor: 'Fator de lucro',
  },

  // Balance Card
  balanceCard: {
    title: 'Saldo e capital',
    startingCapital: 'Capital inicial',
    start: 'Início',
    current: 'Atual',
    capitalAllocation: 'Alocação de capital',
    inOpenTrades: 'Em trades abertos',
    freeCapital: 'Capital livre',
    inTrades: 'Em trades',
    free: 'Livre',
    openPositions: 'Posições abertas',
    withdrawals: 'Retiradas',
    totalWithdrawn: 'Total retirado',
    totalDeposited: 'Total depositado',
    currentBalance: 'Saldo atual',
    summary: 'Resumo',
    totalProfit: 'Lucro total (tudo)',
    noWithdrawals: 'Sem retiradas',
  },

  // Period Profit Card
  periodProfitCard: {
    title: 'Análise de lucro periódico',
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Dados insuficientes para análise periódica',
    weeklyAvg: 'Média semanal',
    monthlyAvg: 'Média mensal',
    week: 'semana',
    month: 'mês',
    dailyBreakdown: 'Detalhamento diário',
    dailyAvg: 'Média diária',
    annualizedReturn: 'Retorno anualizado',
    projections: 'Projeções',
    projectionsDisclaimer: 'À taxa média atual (sem garantia)',
    months: 'meses',
    year: 'ano',
    tradingPeriod: 'Período de trading',
    days: 'dias',
    totalRealized: 'Total realizado',
    belowAverage: 'Abaixo da média',
    belowAverageWarning: 'O desempenho recente pode estar abaixo da média histórica. O CAGR sugere retornos decrescentes.',
    currentMonth: 'Mês atual',
    currentYear: 'Ano atual',
    actual: 'Real',
    projection: 'Projeção',
    target: 'Meta',
    today: 'Hoje',
    onTrack: 'No caminho',
    behind: 'Atrasado',
    ahead: 'Adiantado',
    elapsed: 'decorrido',
    ofTarget: 'da meta',
  },

  // Trades Info Card
  tradesInfoCard: {
    positionOverview: 'Visão geral das posições',
    slots: 'SLOTS',
    allocated: 'alocados',
    currentPositions: 'Posições atuais',
    inDrawdown: 'em drawdown',
    noOpenPositions: 'Sem posições abertas',
    durationAnalysis: 'Análise de duração',
    avgClosedDuration: 'Duração média fechada',
    longestOpen: 'Mais longa aberta',
    anomalyScore: 'Pontuação de anomalia',
    stuck: 'A posição pode estar presa',
    avgDurationLine: 'Duração média de trade fechado',
    durationTooltip: 'Mantida {ratio}x mais que a média',
    capitalExposure: 'Exposição de capital',
    totalAllocated: 'Total alocado',
    avgStake: 'Aposta média / posição',
    largestPosition: 'Maior posição',
    winningPositions: 'Posições vencedoras',
    losingPositions: 'Posições perdedoras',
    winning: 'Vencedoras',
    losing: 'Perdedoras',
    free: 'Livre',
    tradingRhythm: 'Ritmo de trading',
    perDay: 'Trades / dia',
    perWeek: 'Trades / semana',
    avgTimeBetween: 'Tempo médio entre',
    sinceLastTrade: 'Desde o último trade',
    unusuallyQuiet: 'Invulgarmente calmo',
    winRate: 'Taxa de acerto',
    wins: 'ganhos',
    losses: 'perdas',
    total: 'total',
  },

  exchangeCard: {
    type: 'Tipo',
    founded: 'Fundada',
    maxLeverage: 'Alavancagem máx.',
    token: 'Token',
    makerFee: 'Taxa Maker',
    takerFee: 'Taxa Taker',
    fees: 'Taxas',
    headquarters: 'Sede',
    kyc: 'KYC',
    hq: 'Sede',
    tradingTypes: 'Tipos de trading',
    freqtradeSupport: 'Suporte Freqtrade',
    exchangeInfoUnavailable: 'Informações da exchange não disponíveis',
    filterByMode: 'Filtrar bots por {mode}',
  },

  currencyCard: {
    type: 'Tipo',
    peg: 'Paridade',
    peggedTo: 'Indexada a {peg}',
    issuer: 'Emissor',
    backing: 'Garantia',
    chain: 'Cadeia',
    risks: 'Riscos',
    botImpact: 'Impacto no bot',
    currencyInfoUnavailable: 'Informações da moeda não disponíveis',
    filterByCurrency: 'Filtrar bots por {currency}',
  },

  summaryCard: {
    openTitle: 'Lucro aberto — Todos os bots',
    closedTitle: 'Lucro fechado — Todos os bots',
    botRanking: 'Classificação dos bots',
    capitalAtRisk: 'Capital em risco',
    performanceComparison: 'Comparação de desempenho',
    bestBot: 'Melhor desempenho',
    worstBot: 'Pior desempenho',
    avgRoi: 'ROI médio',
    totalWithdrawals: 'Total retirado',
    winrateComparison: 'Comparação de taxa de acerto',
    ofTotal: 'do total',
  },

  summaryWinLoss: {
    title: 'Ganho / Perda — Todos os bots',
    overallWinrate: 'Taxa de acerto global',
    totalTrades: 'Total de trades fechados',
    avgWinrate: 'Taxa de acerto média',
    bestPerformer: 'Melhor taxa de acerto',
    worstPerformer: 'Menor taxa de acerto',
    outOfTrades: 'de {count} trades',
  },

  summaryTrades: {
    title: 'Todas as posições abertas',
    positions: 'posições',
    capacity: 'Capacidade',
    perBot: 'Por bot',
    capitalExposure: 'Exposição de capital',
    multiCurrency: 'Multi-moeda',
    perCurrency: 'Por moeda',
    allCurrencies: 'Todas as moedas',
    winrateComparison: 'Comparação de taxa de acerto',
    balanceTitle: 'Saldo total — Todos os bots',
    totalPerCurrency: 'Total por moeda',
    ratesSource: 'Taxas: CoinGecko',
    ratesUpdated: 'Atualizado há {duration}',
    ratesUnavailable: 'Taxas não disponíveis',
    approximateConversion: 'Conversão aproximada',
    convertedTotal: 'Total convertido',
    conversionRate: 'Taxa',
  },

  // Trading view
  trading: {
    pairsCombined: 'Pares combinados',
    general: 'Geral',
    performance: 'Desempenho',
    balance: 'Saldo',
    timeBreakdown: 'Detalhamento temporal',
    pairlist: 'Lista de pares',
    pairLocks: 'Bloqueios de pares',
    openTrades: 'Trades abertos',
    closedTrades: 'Trades fechados',
    tradeDetail: 'Detalhe do trade',
    chart: 'Gráfico',
    multiPane: 'Multi painel',
    openTradesTitle: 'Trades abertos',
    tradeHistory: 'Histórico de trades',
  },

  // Charts view
  charts: {
    settings: 'Configurações',
    customExchange: 'Exchange personalizada',
    currentExchange: 'Exchange atual',
    strategy: 'Estratégia',
    useLiveData: 'Usar dados ao vivo',
    timeframe: 'Timeframe',
    selectPairs: 'Selecionar pares para plotar',
    refreshChart: 'Atualizar grafico',
    multiPair: 'Multi par',
    hideSimultaneous: 'Ocultar entradas mesma vela',
    showChartAreas: 'Mostrar areas do grafico',
    heikinAshi: 'Heikin Ashi',
    noPairSelected: 'Nenhum par selecionado',
    plotConfigurator: 'Configurador de graficos',
    useLiveDataHint: 'Usar dados ao vivo da exchange. Use apenas se nao tiver dados descarregados localmente.',
    longEntries: 'Entradas long',
    longExits: 'Saidas long',
    shortEntries: 'Entradas short',
    shortExits: 'Saidas short',
    longEntrySignals: 'Sinais de entrada long',
    longExitSignals: 'Sinais de saida long',
  },

  // Empty states
  emptyStates: {
    noTradesYet: 'Sem trades ainda',
    noTradesDesc: 'Este bot ainda não executou nenhum trade. As estatísticas aparecerão após o primeiro trade.',
    noOpenPositions: 'Sem posições abertas',
    noOpenPositionsDesc: 'Tudo limpo — nenhum capital em risco atualmente.',
    noClosedTrades: 'Sem trades fechados',
    noClosedTradesDesc: 'As estatísticas de lucro aparecerão após o fecho do primeiro trade.',
    noTradingActivity: 'Sem atividade de trading',
    noTradingActivityDesc: 'Este bot ainda não registou nenhuma atividade de trading.',
    noWinLossData: 'Sem dados de ganho/perda',
    noWinLossDataDesc: 'As estatísticas de taxa de acerto requerem pelo menos um trade concluído.',
    balanceUnavailable: 'Saldo não disponível',
    balanceUnavailableDesc: 'Os dados de saldo não estão disponíveis para este bot.',
    insufficientHistory: 'Histórico insuficiente',
    insufficientHistoryDesc: 'A análise por período requer pelo menos alguns dias de histórico de trading.',
  },

  time: {
    seconds: '{n} segundo | {n} segundos',
    minutes: '{n} minuto | {n} minutos',
    hours: '{n} hora | {n} horas',
    days: '{n} dia | {n} dias',
    lessThanMinute: 'menos de um minuto',
  },

  // Metric tooltips
  tooltips: {
    roi: 'Retorno sobre investimento — Lucro total como percentagem do capital inicial',
    winrate: 'Percentagem de trades que foram lucrativos',
    cagr: 'Taxa de crescimento anual composta — Retorno anualizado considerando juros compostos',
    sharpe: 'Rácio Sharpe — Retorno ajustado ao risco. Acima de 1 é bom, acima de 2 é excelente',
    sortino: 'Rácio Sortino — Como Sharpe mas só penaliza volatilidade descendente. Maior é melhor',
    sqn: 'System Quality Number — Mede a qualidade do sistema de trading. Acima de 2 é bom, acima de 3 é excelente',
    expectancy: 'Lucro médio esperado por trade em moeda de aposta',
    profitFactor: 'Rácio de lucro bruto para perda bruta. Acima de 1 é lucrativo, acima de 2 é bom',
    maxDrawdown: 'Maior queda de pico a vale no capital. Menor é melhor',
    currentDrawdown: 'Queda atual desde o pico de capital mais recente',
    avgDuration: 'Tempo médio que um trade fica aberto antes de fechar',
    anomalyScore: 'Quanto mais tempo a posição atual é mantida vs a média. Acima de 2x é um aviso',
    tradingVolume: 'Valor total de todos os trades executados',
    calmar: 'Rácio Calmar — CAGR dividido pelo drawdown máximo. Maior significa melhores retornos ajustados ao risco',
    weightedAvgProfit: 'Lucro médio ponderado pelo tamanho da posição — posições maiores contam mais',
    annualizedReturn: 'Retorno anual projetado com base no desempenho atual',
    capacityUtilization: 'Percentagem de posições máximas permitidas atualmente em uso',
    avgWinLossRatio: 'Tamanho médio do trade vencedor dividido pelo perdedor',
    avgProfitPerTrade: 'Percentagem média de lucro em todos os trades fechados',
    // BotInfoCard
    roiAll: 'Retorno incluindo trades abertos e fechados',
    totalTradeCount: 'Número total de trades executados desde o início do bot',
    botStarted: 'Data e hora do primeiro arranque do bot',
    firstTrade: 'Data do primeiro trade executado',
    latestTrade: 'Data do trade mais recente',
    winLoss: 'Número de trades lucrativos vs com perda',
    bestPair: 'Par com o maior rácio de lucro',
    withdrawn: 'Montante total retirado dos lucros do bot',
    netProfit: 'Lucro após subtrair retiradas',
    // OpenProfitCard
    unrealizedPnl: 'Lucro/perda total em posições ainda não fechadas',
    highestLoss: 'Posição aberta com a maior perda não realizada',
    highestGain: 'Posição aberta com o maior ganho não realizado',
    avgPositionProfit: 'Lucro médio simples em todas as posições abertas',
    totalStakeLocked: 'Capital total atualmente alocado em posições abertas',
    pctOfBotBalance: 'Percentagem do saldo total deste bot em posições abertas',
    pctOfAllBots: 'Aposta aberta deste bot como proporção de todos os bots combinados',
    durationAnomaly: 'Compara o tempo de manutenção atual com a duração média do trade fechado. Amarelo >1,5x, Vermelho >2x',
    // ClosedProfitCard
    realizedProfit: 'Lucro total de todos os trades fechados',
    weeklyTrend: 'Tendência de lucro semanal no período recente',
    avgPerTrade: 'Lucro médio por trade fechado',
    tradingPeriod: 'Período do primeiro ao último trade',
    avgProfitWeek: 'Lucro médio ganho por semana',
    avgProfitMonth: 'Lucro médio ganho por mês',
    pctOfTotal: 'Quota deste bot no lucro total de todos os bots selecionados',
    // TradesInfoCard
    capacity: 'Quantos slots de trade estão atualmente em uso vs o máximo permitido',
    capitalAllocation: 'Total de moeda de aposta alocada em posições abertas',
    avgClosedDuration: 'Tempo médio que um trade fechado esteve aberto',
    tradesPerDay: 'Número médio de trades abertos por dia',
    tradesPerWeek: 'Número médio de trades abertos por semana',
    timeBetweenTrades: 'Intervalo médio entre trades consecutivos',
    timeSinceLastTrade: 'Tempo decorrido desde o último trade aberto',
    unusuallyQuiet: 'A atividade de trading está significativamente abaixo da frequência média',
    // BalanceCard
    startingCapital: 'Capital inicial configurado para este bot',
    balanceGrowth: 'Crescimento total do capital inicial ao saldo atual',
    capitalInTrades: 'Montante do saldo atualmente bloqueado em posições abertas',
    freeCapital: 'Saldo disponível para novos trades',
    // PeriodProfitCard
    dailyAvg: 'Lucro médio ganho por dia',
    weeklyAvg: 'Lucro médio ganho por semana',
    monthlyAvg: 'Lucro médio ganho por mês',
    projection1m: 'Lucro estimado em 1 mês à taxa atual',
    projection3m: 'Lucro estimado em 3 meses à taxa atual',
    projection1y: 'Lucro estimado em 1 ano à taxa atual',
    // ExchangeInfoCard
    maxLeverage: 'Alavancagem máxima disponível nesta exchange',
    makerFee: 'Taxa ao colocar ordens limite que adicionam liquidez',
    takerFee: 'Taxa ao colocar ordens de mercado que removem liquidez',
    kycStatus: 'Requisitos de verificação Know Your Customer',
    // CurrencyInfoCard
    pegInfo: 'Valor alvo que esta stablecoin pretende manter',
    backing: 'Ativos que garantem o valor desta moeda',
    riskNote: 'Riscos conhecidos associados a esta moeda',
    botImpact: 'Como esta moeda afeta os cálculos de lucro do bot',
    // Alert detailed tooltips
    alertTooltipPositionLoss: 'Aciona quando uma posição aberta tem uma perda não realizada que excede o limite. Exemplo: com limite de -10%% e uma posição a -12%%, o alerta dispara. Se "Incluir alavancagem" estiver marcado, uma posição alavancada 3x a -4%% é tratada como -12%%.',
    alertTooltipPositionStuck: 'Aciona quando uma posição é mantida significativamente mais tempo que a duração média dos trades. Exemplo: se os trades duram em média 8 horas e o limite é 3x, qualquer posição aberta >24 horas aciona.',
    alertTooltipNearLiquidation: 'Aciona quando uma posição de futuros se aproxima do preço de liquidação. Exemplo: com limite de 15%%, se o preço estiver a 15%% do preço de liquidação, o alerta dispara.',
    alertTooltipLogErrors: 'Aciona quando mensagens de nível ERROR ou CRITICAL aparecem nos logs do bot.',
    alertTooltipOrderFailed: 'Aciona quando o bot falha ao colocar uma ordem. Frequentemente causado por problemas da exchange ou fundos insuficientes.',
    alertTooltipInsufficientFunds: 'Aciona quando o bot não consegue abrir uma posição por falta de fundos.',
    alertTooltipExchangeError: 'Aciona por problemas de conectividade com a exchange: timeouts, limites de taxa, erros de rede.',
    alertTooltipWalletMismatch: 'Aciona quando o bot deteta uma discrepância entre o seu rastreamento e a carteira da exchange.',
    alertTooltipNoTradeActivity: 'Aciona quando nenhum novo trade foi aberto dentro do tempo configurado.',
    alertTooltipBotOffline: 'Aciona imediatamente quando um bot deixa de responder.',
    alertTooltipHighDrawdown: 'Aciona quando o drawdown atual desde o pico do capital excede o limite.',
    alertTooltipCapacityFull: 'Aciona quando todos os slots de trade disponíveis estão ocupados.',
    alertTooltipAllFundsExposed: 'Aciona quando 95%% ou mais do saldo está bloqueado em posições abertas.',
    alertTooltipLiquidationBeforeStoploss: 'Aciona quando o preço de liquidação está mais perto que o stoploss. A posição seria liquidada antes do stoploss ser ativado.',
    // Additional metric tooltips
    currentStreak: 'Número de ganhos ou perdas consecutivos',
    historicalRange: 'Intervalo de duração do trade fechado mais curto ao mais longo',
    medianDuration: 'Valor mediano de todas as durações de trades fechados, menos afetado por valores atípicos',
    currentBalance: 'Saldo total atual deste bot',
    bestBot: 'Bot com o maior retorno sobre investimento',
    worstBot: 'Bot com o menor retorno sobre investimento',
    avgRoiAllBots: 'ROI médio em todos os bots selecionados',
    totalWithdrawalsAllBots: 'Soma de todas as retiradas nos bots selecionados',
    periodReturn: 'Lucro total obtido durante o período selecionado, tanto como valor absoluto quanto como percentual do capital inicial.',
    vsBtc: 'Compara seu lucro total % com a variação de preço do BTC % no mesmo período. Positivo = você superou simplesmente manter BTC.',
  },

  // Stress Test
  stressTest: {
    title: 'Teste de stress',
    estimatedGain: 'Ganho total estimado',
    crash: 'queda',
    pump: 'subida',
    scenarioDesc: 'Em caso de um movimento de mercado repentino e instantâneo, eis o que aconteceria às suas posições abertas atuais. Assume-se um movimento generalizado onde todas as criptomoedas sofrem a mesma flutuação.',
    estimatedImpact: 'Impacto estimado',
    estimatedTotalLoss: 'Perda total estimada',
    crashScenario: 'Cenário de queda do mercado',
    crashOf: 'queda de {pct}%',
    pumpOf: 'subida de {pct}%',
    noOpenPositions: 'Sem posições abertas para teste de stress.',
    liquidation: 'LIQUIDAÇÃO',
    liquidationWarning: '{count} posição(ões) seriam liquidadas',
  },

  // Profit Goal
  profitGoal: {
    title: 'Objetivo',
    settings: 'Configurações do objetivo de lucro',
    targetAmount: 'Montante alvo',
    period: 'Período',
    apply: 'Aplicar',
    monthly: 'Mensal',
    yearly: 'Anual',
  },

  // BotInfoCard labels
  botInfoCard: {
    performance: 'Desempenho',
    timing: 'Temporização',
    drawdown: 'Drawdown',
    strategy: 'Estratégia',
    exchange: 'Exchange',
    port: 'Porta',
    started: 'Iniciado',
    loadingEquity: 'A carregar dados de capital...',
  },

  // AlertDetailCard
  alertDetailCard: {
    alert: 'alerta | alertas',
    liquidationDistance: 'Distância de liquidação',
    problematicPositions: 'Posições problemáticas',
    generalAlerts: 'Alertas gerais',
    ifClosedNow: 'Se fechado agora',
    stakeAtRisk: 'Aposta em risco',
    entry: 'Entrada',
    current: 'Atual',
    remaining: 'restante',
    heldFor: 'Mantida há',
    avgDuration: 'média',
  },

  // ActivityTimeline
  activityTimeline: {
    ago: 'há {time}',
    justNow: 'agora mesmo',
    agoSeconds: 'há {n}s',
    agoMinutes: 'há {n}m',
    agoHours: 'há {n}h',
    agoDays: 'há {n}d',
    searchPlaceholder: 'Pesquisar pares, bots...',
    allBots: 'Todos os bots',
    compactMode: 'Modo compacto',
    noEvents: 'Nenhuma atividade ainda',
    opened: 'Aberto',
    closed: 'Fechado',
    long: 'Long',
    short: 'Short',
    entries: 'entradas',
    dcaAdjustment: 'Ajuste DCA',
    botStatusChange: 'Estado do bot alterado',
    alertTriggered: 'Alerta acionado',
    filterOpened: 'Aberto',
    filterClosedProfit: 'Lucro',
    filterClosedLoss: 'Prejuízo',
    filterDca: 'DCA',
    filterBotStatus: 'Bot',
    filterAlert: 'Alerta',
    eventType: {
      trade_opened: 'Operação aberta',
      trade_closed_profit: 'Operação fechada (lucro)',
      trade_closed_loss: 'Operação fechada (prejuízo)',
      bot_status: 'Estado do bot',
      alert: 'Alerta',
      dca: 'Ajuste DCA',
    },
    goToTradeView: 'Ir para a vista Trade deste bot',
    annotationExceptional: 'Trade excepcional',
    annotationLongDuration: 'Incomumente longo',
    annotationLargestTrade: 'Maior trade',
    group: {
      today: 'Hoje',
      yesterday: 'Ontem',
      thisWeek: 'Esta semana',
      earlier: 'Anterior',
    },
  },

  // Trades Log Enhanced
  tradesLog: {
    allBots: 'Todos os bots',
    filterAll: 'Todos',
    filterOpens: 'Aberturas',
    filterCloses: 'Fechamentos',
    noEntries: 'Nenhum evento de trade ainda',
    opened: 'aberto',
    statTotal: 'Total',
    statOpens: 'Aberturas',
    statWins: 'Ganhos',
    statLosses: 'Perdas',
  },

  // Mercado e desempenho
  marketPulse: {
    tf_today: 'Hoje',
    tf_24h: '24h',
    tf_7d: '7 dias',
    tf_thisWeek: 'Esta semana',
    tf_30d: '30 dias',
    tf_thisMonth: 'Este mês',
    tf_thisYear: 'Este ano',
    tf_1y: '1 ano',
    settings: 'Configurações',
    defaultTimeframe: 'Período padrão',
    sectionMarket: 'Indicadores de mercado',
    sectionPerformance: 'Desempenho dos bots',
    sectionVolume: 'Volume',
    sectionComparison: 'Comparação',
    fearGreed: 'Medo e Ganância',
    extremeFear: 'Medo extremo',
    fear: 'Medo',
    greed: 'Ganância',
    extremeGreed: 'Ganância extrema',
    botPerformance: 'Desempenho dos bots',
    totalProfit: 'Lucro total',
    trades: 'Trades',
    winRate: 'Taxa de acerto',
    bestTrade: 'Melhor trade',
    worstTrade: 'Pior trade',
    bestBot: 'Melhor bot',
    worstBot: 'Pior bot',
    volume: 'Volume',
    volumeByExchange: 'Por exchange',
    volumeByCurrency: 'Por moeda',
    comparison: 'Comparação',
    yourBots: 'Seus bots',
    beatingBtc: 'Superando BTC!',
    underperformingBtc: 'Abaixo do BTC',
    // Popovers
    popoverBtcTitle: 'Preço do Bitcoin',
    popoverPrice: 'Preço',
    popover24hChange: 'Variação 24h',
    popover7dChange: 'Variação 7d',
    popoverSource: 'Fonte',
    popoverFgTitle: 'Índice Medo e Ganância',
    popoverFgDescription: 'Mede o sentimento do mercado de 0 (medo extremo) a 100 (ganância extrema). Baseado em volatilidade, volume, mídias sociais, pesquisas, dominância e tendências.',
    popoverPerf_totalProfit: 'Lucro total',
    popoverPerfDesc_totalProfit: 'Soma dos lucros de todos os trades fechados no período selecionado, convertidos para a moeda de resumo.',
    popoverPerf_trades: 'Número de trades',
    popoverPerfDesc_trades: 'Número total de trades fechados no período selecionado em todos os bots selecionados.',
    popoverPerf_winRate: 'Taxa de acerto',
    popoverPerfDesc_winRate: 'Percentual de trades lucrativos (lucro > 0) entre todos os trades fechados no período.',
    popoverPerf_bestTrade: 'Melhor trade',
    popoverPerfDesc_bestTrade: 'O trade com a maior taxa de lucro no período selecionado.',
    popoverPerf_worstTrade: 'Pior trade',
    popoverPerfDesc_worstTrade: 'O trade com a menor taxa de lucro no período selecionado.',
    popoverPerf_bestBot: 'Melhor bot',
    popoverPerfDesc_bestBot: 'O bot com o maior lucro absoluto total no período selecionado.',
    popoverPerf_worstBot: 'Pior bot',
    popoverPerfDesc_worstBot: 'O bot com o menor lucro absoluto total no período selecionado.',
  },

  // Performance Heatmap
  performanceHeatmap: {
    loadingBenchmarks: 'Carregando dados de benchmark...',
    noData: 'Sem dados de trades disponíveis',
    profit: 'Lucro',
    loss: 'Perda',
    tf_day: 'Por dia',
    tf_week: 'Por semana',
    tf_month: 'Por mês',
  },

  // Risk Overview
  riskOverview: {
    totalExposure: 'Exposição total',
    netExposure: 'Exposição líquida',
    grossExposure: 'Exposição bruta',
    currentExposure: 'Exposição atual',
    deployed: 'empregado',
    of: 'de',
    longLabel: 'Long',
    shortLabel: 'Short',
    avgLeverage: 'Alavancagem média',
    largestPosition: 'Maior posição',
    worstDrawdown: 'Pior drawdown',
    overallPnl: 'PnL aberto geral',
    correlationWarnings: 'Alertas de correlação',
    // Popovers
    popoverExposureTitle: 'Detalhamento da exposição',
    popoverExposureDesc: 'Capital atualmente empregado em posições abertas, detalhado por bot.',
    popoverDrawdownTitle: 'Pior drawdown',
    popoverDrawdownDesc: 'A posição aberta com a maior perda não realizada em percentual.',
    popoverDrawdownPair: 'Par',
    popoverDrawdownPct: 'Drawdown',
    popoverDrawdownBot: 'Bot',
    popoverPnlTitle: 'Detalhamento do PnL aberto',
    popoverPnlDesc: 'Lucro/perda não realizada de todas as posições abertas, detalhado por bot.',
    popoverLeverageTitle: 'Detalhe de alavancagem',
    popoverLeverageDesc: 'Alavancagem média utilizada por cada bot nas posições abertas.',
    popoverCorrelationTitle: 'Alertas de correlação',
    popoverCorrelationDesc: 'Pares negociados simultaneamente por múltiplos bots, aumentando o risco correlacionado.',
    popoverCorrelationNone: 'Nenhum par correlacionado detectado.',
    totalBalanceTooltip: 'Saldo total de todos os bots selecionados',
  },

  // Fleet view
  fleet: {
    title: 'Frota',
    servedBy: 'servido por {bot}',
    refresh: 'Atualizar',
    loading: 'Carregando dados da frota...',
    walletReconciliation: 'Reconciliação da carteira',
    allClear: 'tudo certo',
    issueCount: '{count} problema(s)',
    directionalExposure: 'Exposição direcional',
    pnlContribution: 'Contribuição ao P&L',
    botsPanel: 'Bots',
    errors: {
      overviewFailed: 'Falha ao carregar a visão geral da frota',
      reconciliationFailed: 'Falha ao carregar a reconciliação',
      noServingBot:
        'Nenhum bot conectado suporta o FleetView. Reinicie pelo menos um bot com o backend atualizado.',
      servingBotUnavailable: 'Bot que serve o FleetView indisponível.',
      resolveFailed: 'Falha na solicitação de resolução',
    },
    botsTable: {
      botCount: '{count} bots',
      capital: 'Capital',
      label1d: '1d',
      label7d: '7d',
      label30d: '30d',
      total: 'Total',
      open: 'Abertos',
      filterPlaceholder: 'Filtrar bot / estratégia',
      modeLive: 'Live',
      modeDry: 'Dry',
      modeAll: 'Todos',
      colBot: 'Bot',
      colStrategy: 'Estratégia',
      colDirection: 'Dir',
      colCapital: 'Capital',
      colPnl1d: 'P&L 1d',
      colOpen: 'Abertos',
      colTrades30d: 'Trades 30d',
      colUptime: 'Uptime',
      colAge: 'Idade',
      colPort: 'Porta',
      dryTag: 'DRY',
      frozenTitle: 'Congelado (capital efetivo <= 0)',
      inertTitle: 'Inerte (nenhum trade em 14d)',
      leverageTitle: 'Alavancagem {leverage}x',
      dbUnreadable: 'Banco de dados ilegível',
      durationM: '{m}m',
      durationHM: '{h}h {m}m',
      durationDH: '{d}d {h}h',
    },
    pnl: {
      includeUpnl: 'incluir uPnL (aprox.)',
      sum: 'Soma:',
      nonZeroBots: '{count} bots com contribuição não nula',
      noContribution: 'Nenhuma contribuição nesta janela.',
      window1d: '1d',
      window7d: '7d',
      window30d: '30d',
    },
    exposure: {
      long: 'Long',
      short: 'Short',
      longWord: 'long',
      shortWord: 'short',
      allocatedStake: '(stake alocado, {total} USDC)',
      topNet: 'Principais exposições líquidas on-chain',
      walletNet: 'Líquido da carteira:',
      upnlTitle: 'uPnL {upnl} USDC',
      noPosition: 'Nenhuma posição on-chain.',
    },
    reconciliation: {
      liveBots: '{count} bots live',
      secondsAgo: 'há {seconds}s',
      minutesAgo: 'há {minutes}m',
      noData: 'Nenhum dado de reconciliação.',
      mark: 'mark {price}',
      upnl: 'uPnL',
      dbSays: 'BD diz',
      onChain: 'On-chain',
      gap: 'Diferença',
      sideFlat: 'flat',
      sideLong: 'long',
      sideShort: 'short',
      summaryMinority:
        'A BD e a carteira concordam no total ({chainSide} {chainAmount} {coin}), mas {bot} #{tradeId} detém o lado oposto da posição líquida: as suas saídas são rejeitadas como reduce-only.',
      summaryPhantom:
        'A parte de {bot} #{tradeId} não existe on-chain: a carteira detém {chainSide} {chainAmount} {coin}, totalmente explicado pelos outros bots. É seguro apagar da BD (nenhuma ordem na exchange).',
      summaryUnowned:
        'A carteira detém {chainSide} {chainAmount} {coin}, mas nenhum bot reivindica esta posição.',
      summaryAmbiguous:
        'Os bots reivindicam coletivamente {dbSide} {dbAmount} {coin}, mas a carteira detém {chainSide} {chainAmount} (diferença {gap}). Nenhum trade único explica a diferença: ver o guia de resolução.',
      status: {
        phantom: 'fantasma',
        minority: 'minoritária',
        unowned: 'sem dono',
        ambiguous: 'ambígua',
      },
      hint: {
        phantom:
          'Um bot detém um trade cuja parcela está comprovadamente ausente on-chain. Seguro excluir do seu BD (nenhuma ordem na exchange).',
        minority:
          'O BD corresponde ao on-chain, mas um bot detém o lado OPOSTO da posição líquida. Suas saídas são rejeitadas (reduce-only).',
        unowned:
          'Posição on-chain sem bot dono em nenhum BD. Pode ser zerada com uma ordem reduce-only.',
        ambiguous:
          'BD e on-chain divergem sem uma causa única comprovável. Investigação manual necessária.',
      },
      colBot: 'Bot',
      colTrade: 'Trade',
      colSignedAmount: 'Quantidade com sinal',
      colOpenRate: 'Preço de entrada',
      colStake: 'Stake',
      closeMinority: 'Fechar parcela minoritária',
      deletePhantom: 'Excluir trade fantasma ({bot} #{tradeId})',
      flattenReduceOnly: 'Zerar (reduce-only)',
      manualOnly: 'Intervenção manual necessária, nenhuma ação automática disponível.',
      allInSync: 'Posições do BD e on-chain estão sincronizadas.',
      coinsInSync: '{count} moedas sincronizadas',
      guide: {
        title: 'Guia de resolução',
        refreshNow: 'Atualizar agora',
        refreshFirst:
          'Atualize duas vezes com ~1 min de intervalo. Se a diferença mudar ou desaparecer, era uma ordem em andamento: não faça nada.',
        dust: 'A diferença é poeira (~{notional} USDC). Seguro ignorar. Opcionalmente, zere manualmente com uma ordem reduce-only.',
        multiPhantom:
          '{count} trades são cada um um possível fantasma. Cruze o histórico de fills de cada bot na exchange: o fantasma real é aquele cujo lado está ausente on-chain. Exclua apenas esse (exclusão no BD, nenhuma ordem).',
        multiPhantomItem: '{bot} #{tradeId} ({amount})',
        partialFill:
          'Provável fill parcial não registrado: o trade #{tradeId} de {bot} registrou {dbAmount}, mas o cálculo on-chain implica que apenas {impliedFill} foi realmente preenchido. Verifique os fills do trade na exchange, depois corrija a quantidade no BD, ou aplique o playbook minoritário (parar o bot, ordem inversa sem reduce-only, fechar o trade no BD, relançar).',
        staleDb:
          'Nada se reconcilia: provavelmente um bot parado cujo BD ainda contém trades abertos (invisíveis para esta varredura). Verifique os bancos dos bots parados recentemente antes de tocar em qualquer coisa.',
        footer:
          'Nunca toque em estratégias ou alavancagem para corrigir problemas de netting. Verifique novamente com uma atualização forçada após cada ação.',
      },
      dialog: {
        deletePhantomTitle: 'Excluir trade fantasma em {coin}',
        closeMinorityTitle: 'Fechar parcela minoritária em {coin}',
        flattenUnownedTitle: 'Zerar posição sem dono em {coin}',
        warnDeletePhantom:
          'O trade será removido do banco de dados do bot. Nenhuma ordem é colocada na exchange.',
        warnCloseMinority:
          'Uma ordem a mercado SEM reduce-only será colocada para realinhar a carteira, depois o trade travado será excluído do banco do bot. O P&L deste trade NÃO será registrado nas estatísticas do bot.',
        warnFlattenUnowned:
          'Uma ordem a mercado reduce-only será colocada para zerar a posição on-chain. Reduce-only só pode reduzir a posição, nunca invertê-la.',
        coin: 'Moeda',
        bot: 'Bot',
        trade: 'Trade',
        amount: 'Quantidade',
        estNotional: 'Nocional est.',
        done: 'Concluído',
        orderResult: "Ordem {id}: preenchida {filled} {'@'} {avg} ({notional} USDC)",
        dbDelete: 'Exclusão no BD:',
        close: 'Fechar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      realign: {
        button: 'Realinhar o BD',
        title: 'Realinhar o BD com o on-chain, {coin}',
        dbOnly:
          'Ação apenas no BD: nenhuma ordem será colocada na exchange. Somente os bancos de dados dos bots são reescritos para corresponder à posição on-chain.',
        intro:
          'Escolha o que fazer com cada parcela no BD para que a soma corresponda à posição líquida on-chain. No máximo uma parcela pode ser ajustada; parcelas fechadas são removidas por completo.',
        colAction: 'Ação',
        colNewAmount: 'Nova quantidade',
        keep: 'Manter',
        closeOp: 'Fechar',
        adjustOp: 'Ajustar',
        onlyOneAdjust: 'Apenas uma parcela pode ser ajustada por plano.',
        resulting: 'Soma resultante:',
        target: 'Alvo on-chain:',
        withinTolerance: 'compatível (2%)',
        outsideTolerance: 'incompatível',
        previewBtn: 'Pré-visualizar',
        colBefore: 'Antes',
        colAfter: 'Depois',
        colDelta: 'Delta',
        colNotional: 'Nocional do delta',
        touchedNotional: 'Nocional tocado: {notional} USDC',
        backBtn: 'Voltar',
        applyBtn: 'Aplicar (só BD)',
        resultsTitle: 'Resultados',
      },
    },
  },

  // Summary cards
  summaryCards: {
    bots: 'bots',
    shareOfTotalProfit: 'Quota do lucro total',
    profitOfTotal: '{profit} de {total} (todos os bots)',
    pctOfBotBalance: '% do saldo deste bot',
    pctOfAllBotsOpenPositions: '% das posições abertas (todos os bots)',
  },
};
